import { merge, Observable } from 'rxjs'
import actions from '../../../actions/slides'

export default function (doc, getUpdatedValues) {

  return new Observable(observer =>
    merge(
      doc.on('updated', ({ data: docEntry }) => {

        for (const [key, data] of getUpdatedValues(docEntry)) {

          switch (key) {

            case 'slideDecks':
              observer.next(actions.setSlideDecks(data))
              break
            default:
              break

          }

        }

      }),
      doc.on('removed', () => {

        observer.complete()

      })
    )
  )

}
